import { PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';
import $ from 'jquery';

const $site = $('.site');
const FREQUENCY = $site.data('frequency')

export function dspFinance(item, frequency = FREQUENCY) {
  const { adjusted_price, rules = [], tax_rate = 0 } = item.pricing.finance;

  if (rules.length > 0) {
    let { from, value } = rules.at(-1);
    let calcInputs = {
      price: adjusted_price,
      down: 0,
      term: from,
      rate: value,
      tradein: 0,
      tax: tax_rate,
    };

    return dspCalculatePayment(calcInputs, 'finance', frequency);
  } else {
    return '--';
  }
}

export function dspLease(item, frequency = FREQUENCY ) {
  const { adjusted_price, rules = [], tax_rate = 0 } = item.pricing.lease;

  if (rules.length > 0) {
    let { from, value, residual_value } = rules.at(-1);
    let calcInputs = {
      price: adjusted_price,
      down: 0,
      term: from,
      rate: value,
      tradein: 0,
      tax: tax_rate,
      residual: residual_value,
    };
    return dspCalculatePayment(calcInputs, 'lease', frequency);
  } else {
    return '--';
  }
}

function dspCalculatePayment(calcInputs, calculatorType, frequency = FREQUENCY) {
  console.log('dspCalc() called with frequency: ', frequency);
  let payment = '--';
  if (['finance', 'lease'].includes(calculatorType)) {
    const newCalc = PaymentCalculatorFactory.createCalculator(calculatorType, calcInputs);

    newCalc.calculate();
    payment = newCalc.payments[frequency];
  }
  return payment;
}
